import React, { useState, useEffect, useMemo } from "react";
import { Button, Table, Spinner } from "react-bootstrap";
import { useTable, usePagination, useGlobalFilter, useSortBy } from "react-table";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useDispatch } from "react-redux";
import { Fn_FillListData, Fn_DeleteData } from "../../store/Functions";
import { useNavigate } from "react-router-dom";
import ExportButtons from "../../components/ExportButtons";

const PageList_VehicleMaster = () => {
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const API_URL = `${API_WEB_URLS.MASTER}/0/token/VehicleMaster`;

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      Fn_FillListData(dispatch, setGridData, "gridData", API_URL + "/Id/0");
      setLoading(false);
    };
    fetchData();
  }, [dispatch, API_URL]);

  const data = useMemo(() => gridData || [], [gridData]);
  const columns = useMemo(
    () => [
      { Header: "Number", accessor: "VehicleNumber", Cell: ({ value }) => <span style={{ fontSize: 12 }}>{value || "-"}</span> },
      { Header: "Type", accessor: "VehicleType", Cell: ({ value }) => <span style={{ fontSize: 11 }}>{value || "-"}</span> },
      { Header: "Brand", accessor: "Brand", Cell: ({ value }) => <span style={{ fontSize: 11 }}>{value || "-"}</span> },
      { Header: "Model", accessor: "Model", Cell: ({ value }) => <span style={{ fontSize: 11 }}>{value || "-"}</span> },
      { Header: "Year", accessor: "Year", Cell: ({ value }) => <span style={{ fontSize: 11 }}>{value || "-"}</span> },
      { Header: "Owner", accessor: "OwnerName", Cell: ({ value }) => <span style={{ fontSize: 11 }}>{value || "-"}</span> },
      { id: "actions", Header: "", Cell: ({ row }) => (
        <div style={{ display: "flex", gap: 4 }}>
          <Button size="sm" variant="outline-primary" className="py-0 px-1" style={{ fontSize: 11 }} onClick={() => navigate("/AddVehicleMaster", { state: { Id: row.original.Id } })}>Edit</Button>
          <Button size="sm" variant="outline-danger" className="py-0 px-1" style={{ fontSize: 11 }} onClick={() => { if (window.confirm("Delete?")) Fn_DeleteData(dispatch, row.original.Id, API_URL, API_URL + "/Id/0").then((r) => r?.success && Fn_FillListData(dispatch, setGridData, "gridData", API_URL + "/Id/0")); }}>Del</Button>
        </div>
      ) },
    ],
    [dispatch, navigate, API_URL]
  );

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page, canPreviousPage, canNextPage, pageOptions, pageCount, gotoPage, nextPage, previousPage, setPageSize, state: { pageIndex, pageSize, globalFilter }, setGlobalFilter } = useTable(
    { columns, data, initialState: { pageIndex: 0, pageSize: 15, sortBy: [{ id: "VehicleNumber", desc: false }] } },
    useGlobalFilter, useSortBy, usePagination
  );

  if (loading) return (<div style={{ padding: "6px 8px", display: "flex", justifyContent: "center", alignItems: "center", minHeight: 120 }}><Spinner animation="border" size="sm" /></div>);

  return (
    <div style={{ padding: "6px 8px", maxWidth: 1200, margin: "0 auto" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4, paddingBottom: 4, borderBottom: "1px solid #dee2e6" }}>
        <span style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>Vehicle Master</span>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <ExportButtons title="Vehicle Master Report" columns={columns} data={data} filename="Vehicle_Master" />
          <input type="text" placeholder="Search" value={globalFilter || ""} onChange={(e) => setGlobalFilter(e.target.value)} className="form-control form-control-sm" style={{ width: 140, height: 26, fontSize: 12 }} />
          <Button size="sm" variant="primary" className="py-0 px-2" style={{ fontSize: 12, height: 26 }} onClick={() => navigate("/AddVehicleMaster", { state: { Id: 0 } })}>+ Add</Button>
        </div>
      </div>
      <div style={{ overflowX: "auto", marginBottom: 4 }}>
        <Table {...getTableProps()} size="sm" bordered hover style={{ fontSize: 12, minWidth: 700 }}>
          <thead>
            {headerGroups.map((headerGroup, i) => (
              <tr {...headerGroup.getHeaderGroupProps()} key={i}>
                {headerGroup.headers.map((col, j) => (
                  <th {...col.getHeaderProps(col.getSortByToggleProps())} key={j} style={{ padding: "4px 6px", fontSize: 11, fontWeight: 600, backgroundColor: "#E87B2D", color: "#fff" }}>{col.render("Header")}{col.isSorted && <span style={{ marginLeft: 2 }}>{col.isSortedDesc ? "▼" : "▲"}</span>}</th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell, j) => <td {...cell.getCellProps()} key={j} style={{ padding: "3px 6px", verticalAlign: "middle" }}>{cell.render("Cell")}</td>)}
              </tr>
            );
          })}
        </tbody>
        </Table>
      </div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 11, flexWrap: "wrap", gap: 4 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span>Page {pageIndex + 1} of {pageOptions.length || 1}</span>
          <select className="form-select form-select-sm" style={{ width: 50, height: 24, fontSize: 11 }} value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
            {[10, 15, 20, 30, 50].map((n) => <option key={n} value={n}>{n}</option>)}
          </select>
          <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-1" style={{ fontSize: 11 }} onClick={() => gotoPage(0)} disabled={!canPreviousPage}>|«</button>
          <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-1" style={{ fontSize: 11 }} onClick={() => previousPage()} disabled={!canPreviousPage}>‹</button>
          <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-1" style={{ fontSize: 11 }} onClick={() => nextPage()} disabled={!canNextPage}>›</button>
          <button type="button" className="btn btn-sm btn-outline-secondary py-0 px-1" style={{ fontSize: 11 }} onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>»|</button>
        </div>
      </div>
    </div>
  );
};

export default PageList_VehicleMaster;
